// extracted by mini-css-extract-plugin
export default {"messageContainer":"withComponent__messageContainer--1Dn","wcContent":"withComponent__wcContent--1ZU"};